import React , {useState,useEffect} from 'react'
import { emptyAvatar } from "../../imagepath";
import { getFile } from "../../../lib/file"


// eslint-disable-next-line react/prop-types
export default function StudentBox(data) {
    const { name, surname, id, schoolname, avatar_url, isActive } = data.data;
    const [avatar, setAvatar] = useState();
    //console.log("data",data);
    
    async function GetData() {
        if(avatar_url)
      {  const avt = await getFile(avatar_url);
        setAvatar(avt.publicUrl);}
    }

    useEffect(() => {
        GetData();
    }, [avatar_url])

    return (
        <div className="col-xl-6 col-lg-6 col-md-6 d-flex" key={id}>
            <div className="student-box flex-fill">
                <div className="student-box-blks">
                    <div className="student-img">
                        <img
                            className="img-fluid rounded-circle"
                            alt="Students Info"
                            src={avatar ? avatar :emptyAvatar}
                        />
                    </div>
                    <div className="student-content pb-0">
                        <h5>
                            {name + " " + surname} {isActive ? (
                    <i className='fas fa-circle-check green h3'></i>
                ) : (
                    <i className='fas fa-minus-circle red h3'></i>
                )}
                        </h5> 
                        <div className="loc-blk d-flex align-items-center justify-content-center">
                            <i className="feather-map-pin me-2"></i>
                            <p>{schoolname}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
